import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import "../../assets/css/Subscription_payment.css";
import { googlepay, master, paypal, visa } from "../../constants";
import { redirect, useLocation } from "react-router-dom";

const Subscription_payment = () => {
	function RedirectToHome() {
		window.location.href = "/";
	}
	return (
		<>
			{/* Modal popup starts here */}
			<div
				className="modal fade"
				id="exampleModal"
				tabindex="-1"
				aria-labelledby="exampleModalLabel"
				aria-hidden="true"
			>
				<div className="modal-dialog">
					<div className="modal-content">
						<div className="modal-content-wrapper">
							<div className="icon-wrapper">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="75.292"
									height="75.301"
									viewBox="0 0 75.292 75.301"
								>
									<path
										id="Icon_awesome-check-double"
										data-name="Icon awesome-check-double"
										d="M74.264,25.706l-5.823-5.823a3.515,3.515,0,0,0-4.985,0L28.238,55.1l-16.381-16.4a3.515,3.515,0,0,0-4.985,0L1.033,44.544a3.532,3.532,0,0,0,0,5l24.7,24.719a3.515,3.515,0,0,0,4.985,0L74.25,30.706A3.546,3.546,0,0,0,74.264,25.706ZM26.576,41.294a2.334,2.334,0,0,0,3.323,0L60.486,10.678a2.361,2.361,0,0,0,0-3.323L53.839.693a2.334,2.334,0,0,0-3.323,0L28.238,22.971,20.091,14.81a2.334,2.334,0,0,0-3.323,0l-6.661,6.661a2.361,2.361,0,0,0,0,3.323Z"
										transform="translate(0.004 0.002)"
										fill="#3e7439"
									/>
								</svg>
							</div>
							<div className="pop-content-wrapper">
								<h3>Your Subscription Payment Was Successful Paid</h3>
								<p>
									your subscription payment has been <br /> successful done
								</p>
								<a href="/MyProfile" className="btn">
									Go To Home Page
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* Modal popup ends here */}
			{/* Header starts here */}
			<Header />
			{/* Header ends here */}
			{/* Subsccription payment starts here */}
			<section className="subs-payment">
				<div className="container">
					<div className="row">
						<div className="col-lg-3"></div>
						<div className="col-lg-6">
							<div className="heading-wrapper mb-5">
								<h5>Subscription Payment</h5>
							</div>
							<div className="payment-card-wrapper">
								<div className="payment-heading-wrapper">
									<h6>Payment</h6>
								</div>
								<div className="payment-form-wrapper">
									<form action="/">
										<div className="form-group">
											<label htmlFor="">Card Name</label>
										</div>
										<div className="form-group row">
											<div className="col-lg-8">
												<input
													type="text"
													className="form-control number"
													placeholder="*123456789789"
												/>
											</div>
											<div className="col-lg-2">
												<input
													type="text"
													className="form-control date"
													placeholder="MM/YY"
												/>
											</div>
											<div className="col-lg-2">
												<input
													type="text"
													className="form-control cvc"
													placeholder="Cvc"
												/>
											</div>
										</div>
										<div className="form-group">
											<label htmlFor="">Card Name</label>
										</div>
										<div className="form-group">
											<ul className="cards-list-wrapper">
												<li className="card-wrapper">
													<label htmlFor="flexRadioDefault10">
														<input
															type="radio"
															name="radio"
															id="flexRadioDefault10"
														/>
														<img src={visa} alt="" />
													</label>
												</li>
												<li className="card-wrapper">
													<label htmlFor="flexRadioDefault11">
														<input
															type="radio"
															name="radio"
															id="flexRadioDefault11"
														/>
														<img src={googlepay} alt="" />
													</label>
												</li>
												<li className="card-wrapper">
													<label htmlFor="flexRadioDefault12">
														<input
															type="radio"
															name="radio"
															id="flexRadioDefault12"
														/>
														<img src={master} alt="" />
													</label>
												</li>
												<li className="card-wrapper">
													<label htmlFor="flexRadioDefault13">
														<input
															type="radio"
															name="radio"
															id="flexRadioDefault13"
														/>
														<img src={paypal} alt="" />
													</label>
												</li>
											</ul>
										</div>
									</form>
								</div>
								<div className="package-details-wrapper">
									<div className="package-header-wrapper">
										<h5>Package Details</h5>
										<button className="btn">Change Packages</button>
									</div>
									<div className="package-content-wrapper">
										<h5 className="property">Per Month</h5>
										<h5 className="value">$75.00</h5>
									</div>
								</div>
								<button
									className="btn form-submit"
									data-bs-toggle="modal"
									data-bs-target="#exampleModal"
									type="submit"
								>
									Pay Now
								</button>
							</div>
						</div>
						<div className="col-lg-3"></div>
					</div>
				</div>
			</section>
			{/* Subsccription payment ends here */}
			{/* Footer starts here */}
			<Footer />
			{/* Footer ends here */}
		</>
	);
};

export default Subscription_payment;
